import { React } from 'react';
import styled from 'styled-components';

const SalesList = (props) => {
  const { data, isOver, onClickSalesList } = props;

  return (
    <TopLevelWrapper>
      <Table isOver={isOver}>
        <Body isOver={isOver}>
          <HeadTr isOver={isOver}>
            <Td style={{ minWidth: `26px`, marginRight: `41px`, marginLeft: '8px' }} isOver={isOver}>이름</Td>
            <Td style={{ minWidth: `28px`, marginRight: `40px` }} isOver={isOver}>구분</Td>
            <Td style={{ minWidth: `68px`, marginRight: `200px` }} isOver={isOver}>결제 회원권</Td>
            <Td style={{ minWidth: `52px`, marginRight: `39px` }} isOver={isOver}>결제금액</Td>
            <Td style={{ minWidth: `26px`, marginRight: `65px` }} isOver={isOver}>카드</Td>
            <Td style={{ minWidth: `26px`, marginRight: `65px` }} isOver={isOver}>현금</Td>
            <Td style={{ minWidth: `39px`, marginRight: `52px` }} isOver={isOver}>미수금</Td>
            <Td style={{ minWidth: `61px` }} isOver={isOver}>결제일</Td>
          </HeadTr>
          {
            data.map((data, index) => (
              <BodyTr key={index} onClick={() => onClickSalesList(data)}>
                <Td style={{ width: `60px`, marginLeft: '10px', overflow: 'hidden' , whiteSpace: 'nowrap', textOverflow: 'ellipsis' }} isOver={isOver}>
                  {data.name}
                </Td>
                <Td style={{ width: `67px`, marginLeft: '7px' }} isOver={isOver}>
                  {data.price - (data.cashPrice + data.cardPrice) > 0 ? '미수금' : '수금'}
                </Td>
                <Td style={{ width: `268px` }} isOver={isOver}>
                 {data.itemName}
                </Td>
                <Td style={{ width: `91px` }} isOver={isOver}>
                  {data.originalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </Td>
                <Td style={{ width: `91px` }} isOver={isOver}>
                  {data.cardPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </Td>
                <Td style={{ width: `91px` }} isOver={isOver}>
                  {data.cashPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </Td>
                <Td style={{ width: `91px` }} isOver={isOver}>
                  {data.price - (data.cashPrice + data.cardPrice) > 0 ? (data.price - (data.cashPrice + data.cardPrice)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0}
                </Td>
                <Td style={{ width: `76px` }} isOver={isOver}>
                  {data.approvalDate.split('T')[0][2]
                  + data.approvalDate.split('T')[0][3]
                  + '.'
                  + data.approvalDate.split('T')[0][5]
                  + data.approvalDate.split('T')[0][6]
                  + '.'
                  + data.approvalDate.split('T')[0][8]
                  + data.approvalDate.split('T')[0][9]}
                </Td>
              </BodyTr>
            ))
          }
        </Body>
      </Table>
    </TopLevelWrapper>
  )
}

export default SalesList;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Table = styled.table`
  display: flex;
  flex-direction: column;

  width: ${props => props.isOver ? `max(659px, 85.80729166666667vw)` : `max(262px, 81.875vw)`};
  height: ${props => props.isOver ? `428px` : `188px`};

  overflow: scroll;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  height: ${props => props.isOver ? `428px` : `188px`};

  margin-top: ${props => props.isOver ? `16px` : `4px`};

  overflow-y: scroll;
  overflow-x: none;

  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  &::-webkit-scrollbar-thumb {
		border: 3px solid transparent;
		// height: 92px;
		background-color: #DADADA;
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
    // height: 439px;
		// border: 4px solid transparent;
		background-color: #F0F0F0;
		border-radius: 200px;
	}
`;

const HeadTr = styled.tr`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  height: ${props => props.isOver ? `32px` : `16px`};

  margin-top: ${props => props.isOver ? `16px` : `8px`};
  padding-bottom: ${props => props.isOver ? `16px` : `8px`};

  border-bottom: 1px solid #ECECEC;
  border-radius: 8px;
  // background-color: #ECECEC;
`;

const BodyTr = styled.tr`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #F4F2F0;
  }
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  font-family: NotoSansKR-Regular;
  font-size: ${props => props.isOver ? `14px` : `10px`};

  height: ${props => props.isOver ? `36px` : `15px`};

  color: #595959;
`;